import { Modal, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TableComponent from "@components/TableComponent/TableComponent";
import ButtonComponent from "@components/ButtonComponent";
import { useState } from "react";
import { sheetPublishAdSet } from "@services/sheetCreateAdSet";
import { notify } from "@utils/notify";
import { Loader } from "@components/Loader";

const SheetSummaryModal = ({
  open,
  onClose,
  adCountsSummary = [],
  isOneAdPerAdSet = false,
  userId,
  adAccountId,
  rowsToProcess,
  selectedFB,
  selectedIG,
  sheetUrl,
  existingAdsets,
  columnLetter
}) => {

  const [isTypeSwitchOn, setIsTypeSwitchOn] = useState(false);

  // Table columns with proper wrapping styles
  const columns = [
    {
      key: 'campaignName',
      label: 'Campaign Name',
      width: '150px',
      cellStyle: {
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        overflow: 'hidden'
      }
    },
    {
      key: 'adsetName',
      label: 'Adset Name',
      width: '400px',
      cellStyle: {
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        overflow: 'hidden'
      }
    },
    {
      key: 'adCount',
      label: 'Ad Count',
      width: '75px',
      tdClass: 'text-center',
      cellStyle: {
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        overflow: 'hidden'
      }
    },
  ];


  // Map adCountsSummary array to table data
  let data = [];
  if (adCountsSummary) {
    data = adCountsSummary.map(item => ({
      campaignName: item["Campaigns"] || '',
      adsetName: item["Adset Name"] || '',
      adCount: item["ad_count"] || '',
    }));
  }

  const handleTypeSwitchChange = (event) => {
    setIsTypeSwitchOn(event.target.checked);
  };

  // Handler for Publish Ads button
  const [isPublishing, setIsPublishing] = useState(false);
  const navigate = useNavigate();
  const handlePublishAds = async () => {
    setIsPublishing(true);
    const payload = {
      user_id: userId,
      ad_account_id: adAccountId,
      sheet_url: sheetUrl,
      rows_to_process: rowsToProcess,
      existing_adsets: existingAdsets,
      fb_page_id: selectedFB,
      insta_page_id: selectedIG,
      status_column: columnLetter,
      one_ad_per_adset: isOneAdPerAdSet,
      fb_ad_live_status: isTypeSwitchOn ? 'ACTIVE' : 'PAUSED'
    };
    try {
      const response = await sheetPublishAdSet(payload);
      if (response && response.success) {
        notify('Ads published successfully!', 'success');
        navigate('/launch-history');
      }
    } catch (err) {
      console.error("Publish Ads error:", err);
    } finally {
      setIsPublishing(false);
    }
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="sheet-error-modal-title"
      aria-describedby="sheet-error-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 1000,
          maxHeight: 700,
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 0,
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          border: "1px solid #E5E7EB",
        }}
      >
        {isPublishing && (
          <div className="absolute inset-0 z-50 flex items-center justify-center bg-white bg-opacity-70">
            <Loader />
          </div>
        )}
        {/* Ghost close button at top right */}
        <ButtonComponent
          onClick={onClose}
          className="absolute text-gray-400 transition-colors right-5 top-5 hover:text-gray-600"
          variant="ghost"
          aria-label="Close"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </ButtonComponent>
        <h2
          id="sheet-error-modal-title"
          className="font-inter font-medium not-italic text-[20px] leading-[1.2] tracking-[-0.01em] mb-[24px] text-left w-full"
        >
          Summary
        </h2>
        <div className="mb-[24px]" style={{ width: '100%' }}>
          <TableComponent
            columns={columns}
            data={data}
            headerCellStyle={{ fontWeight: 'font-normal', fontSize: 'text-[15px]', fontColor: 'text-[#6B7280]' }}
            styleProps={{ maxBodyHeight: 400 }}
          />
        </div>

        <div className="flex items-center justify-between w-full">
          <ButtonComponent
            isSwitch
            switchProps={{
              checked: isTypeSwitchOn,
              onChange: handleTypeSwitchChange,
              inputProps: { 'aria-label': 'Type Switch' },
              color: 'primary',
            }}
            switchLabel="Ad Set Active"
            className="font-inter text-sm text-[#1F1F1F]"
            style={{ minWidth: 120 }}
          />
          <ButtonComponent
            onClick={handlePublishAds}
            variant="primary"
            style={{ minWidth: 120 }}
          >
            Publish Ads
          </ButtonComponent>
        </div>
      </Box>
    </Modal>
  );
};

export default SheetSummaryModal;